<template>
   <v-form v-model="valid">
    <v-container>
      <v-row>
        <v-col
          cols="12"
         
        >
          <v-img src="/assets/kilostop.jpg" aspect-ratio="1.7"></v-img>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="firstname"
            :rules="nameRules"
            :counter="20"
            label="Nome"
            required
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="lastname"
            :rules="nameRules"
            :counter="20"
            label="Cognome"
            required
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="phone"
            :rules="phoneRules"
            label="Telefono"
            required
          ></v-text-field>
        </v-col>
      
      <v-col
          cols="12"
          
        >
        <v-btn  :disabled=!valid block x-large color="success">Richiedi informazioni</v-btn>
      </v-col>
      </v-row>

        
    </v-container>
  </v-form>
</template>

<script>
  export default {
    name: 'Form',

    data: () => ({
     valid: false,
      firstname: '',
      lastname: '',
      nameRules: [
        v => !!v || 'è richiesto fornire il nome',
        v => v.length <= 20 || 'Deve essere meno di 20 caratteri',
      ],
      phone: '',
      phoneRules: [
        v => !!v || 'è richiesto il numero di telefono',
        v => /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) || 'Deve essere un numero di telefono valido',
      ],
    }),
  }
</script>
